import {SnotifyToastConfig} from 'vue-snotify'
import {$} from '@/facade'

export abstract class ToastHelper {
  static success(
    body: string,
    title?: string,
    useI18n = true,
    config: SnotifyToastConfig = {}
  ) {
    if (useI18n)
      $.snotify.success(
        $.translate(body),
        title ? $.translate(title) : '',
        config
      )
    else $.snotify.success(body, title || '', config)
  }

  static error(
    body: string,
    title?: string,
    useI18n = true,
    config: SnotifyToastConfig = {}
  ) {
    if (useI18n)
      $.snotify.error(
        $.translate(body),
        title ? $.translate(title) : '',
        config
      )
    else $.snotify.error(body, title || '', config)
  }

  static abort(
    body: string,
    title?: string,
    useI18n = true,
    config: SnotifyToastConfig = {}
  ) {
    this.error(body, title, useI18n, config)
    throw new Error(useI18n ? $.translate(body) : body)
  }

  static warning(
    body: string,
    title?: string,
    useI18n = true,
    config: SnotifyToastConfig = {}
  ) {
    if (useI18n)
      $.snotify.warning(
        $.translate(body),
        title ? $.translate(title) : '',
        config
      )
    else $.snotify.warning(body, title || '', config)
  }

  static info(
    body: string,
    title?: string,
    useI18n = true,
    config: SnotifyToastConfig = {}
  ) {
    if (useI18n)
      $.snotify.info($.translate(body), title ? $.translate(title) : '', config)
    else $.snotify.info(body, title || '', config)
  }
}
